import React from "react";
import { Box, Stack, TextField } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import HttpService from "../../Hooks/Https-services";
import { APIRoutes, PageRoutes } from "../../Utils/constant";
import { toast } from "react-toastify";
import { getCurrentAuth, setAuth } from "../../Hooks/http-server";
import { Navigate, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
// Validation schema using Yup
const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const Login = () => {
  const navigate = useNavigate();
  const auth = getCurrentAuth();
  const handleSubmit = async (values: { email: string; password: string }) => {
    try {
      const res = await HttpService.postAuth(APIRoutes.Login, {
        email: values.email,
        password: values.password,
      });
      const data = {
        AccessToken: res.data.accessToken,
        RefreshToken: res.data.refreshToken,
      };
      toast.success(res.data.message);
      setAuth(data);

      navigate(PageRoutes.Home);
    } catch (error) {}
  };
  if (auth.AccessToken) {
    return <Navigate to={PageRoutes.Home} />;
  }
  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={LoginSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <Box
            sx={{
              px: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100vh",
              justifyContent: "center",
            }}
          >
            <Stack gap={2}>
              <Field
                as={TextField}
                size="small"
                name="email"
                placeholder="Email"
                fullWidth
                sx={{ minWidth: 300 }}
                error={touched.email && !!errors.email}
                helperText={touched.email && errors.email}
              />
              <Field
                as={TextField}
                size="small"
                name="password"
                placeholder="Password"
                fullWidth
                type="password"
                error={touched.password && !!errors.password}
                helperText={touched.password && errors.password}
              />
              <LoadingButton
                loading={isSubmitting}
                type="submit"
                variant="contained"
              >
                Login
              </LoadingButton>
            </Stack>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default Login;
